module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("This book is a work of fiction. Unless otherwise indicated, all the names, characters, businesses, places, events, and incidents in this book are either the product of the author's imagination or used in a realistic fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_c('i', [_vm._v("60 Days of Pleasure")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Copyright © 2021 by Dr. Vanessa Howard")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("All rights reserved.")])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Without limiting the rights under copyright reserved above, no part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the express written permission of both the copyright owner and the publisher of this book, except in the case of brief quotations embodied in critical articles and reviews. For permission, contact Dr. Vanessa Howard at "), _c('span', {
    staticClass: "underline"
  }, [_c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "http://www.drvanessahoward.com",
      "target": "_blank"
    }
  }, [_vm._v("www.drvanessahoward.com")]), _vm._v(" or drvhoward@gmail.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("The scanning, uploading, and distribution of this book via the Internet or via any other means without the permission of the owner is illegal and punishable by law. Please purchase only authorized electronic editions and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Howard Univer-City, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("12685 Dorsett Road PMB 225")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Maryland Heights, MO 63043-2380")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Cover Designed by: J.L Woodson: "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.woodsoncreativestudio.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.woodsoncreativestudio.com")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Interior Designed by: Lissa Woodson: "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.naleighnakai.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.naleighnakai.com")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Editor: Lissa Woodson: "), _c('span', {
    staticClass: "underline"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.naleighnakai.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.naleighnakai.com")])]), _vm._v(" and")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Editor: J. L. Campbell: "), _c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "mailto:jlcampbellwrites@gmail.com"
    }
  }, [_vm._v("jlcampbellwrites@gmail.com")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Beta Reader by D J. Mitchell: "), _c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "mailto:minibyme@aol.com"
    }
  }, [_vm._v("minibyme@aol.com")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Beta Reader by Anita Wade: "), _c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "mailto:arwade.aw@gmail.com"
    }
  }, [_vm._v("arwade.aw@gmail.com")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Beta Reader by Christine Pauls: "), _c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "mailto:cpauls49@yahoo.com"
    }
  }, [_vm._v("cpauls49@yahoo.com")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBOOK ISBN: ")]), _vm._v("9781952871214")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Trade book ISBN 978-1-7366987-2-3")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0